import ApplicantDocumentHandlerView from "./ApplicantDocumentHandlerView.component";

export default ApplicantDocumentHandlerView;
